/* eslint-disable no-magic-numbers */
import React from "react";
import PropTypes from "prop-types";
import { Slider as CompoundSlider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import SliderRail from "./slider-rail";
import Handle from "./handle";
import Track from "./track";
import Tick from "./tick";
import styles from "./styles.css";
import { trackC2bMobileCustomEvents } from "../../../au-c2b/tracking";
import { C2B_AU_MOBILE_EVENTS } from "../../../au-c2b/tracking/c2b-mobile-events";

const Slider = ({
    domain = [1, 10],
    defaultValues = [5],
    step = 1,
    mode = 2,
    tickCount = 8,
    onChange = () => {},
    onUpdate = () => {},
    percentageHandler = () => {},
    showPercentage = false,
    hideHandles = [],
    railColor = "#dde5eb",
    disabledTrackStyles = {
        backgroundImage: "linear-gradient(269deg, #4736FE, #6B5CFF)"
    },
    onSlideStart = () => {},
    onSlideEnd = () => {},
    animatedHandles = [],
    handleColor = "orange",
    trackProps = { right: false },
    hideTicksOnEdges = true,
    disabled = false,
    getHandleID = () => {},
    trackStyle = {},
    tickStyle = {},
    tickTextStyle,
    trackSliderInnerStyle = {},
    sliderTicksStyle = {},
    handleStyle = {},
    sliderWrapperStyle = {},
    ticksWrapperStyle = {},
    showTickText,
    mainDivisorHeight,
    orderId,
    gaId,
    gaDataOnload,
    localState = {}
}) => {

    React.useEffect(() => {
        if (typeof gaDataOnload === "function") {
            const gaData = gaDataOnload(localState);
            trackC2bMobileCustomEvents(C2B_AU_MOBILE_EVENTS[gaData.eventName], {
                eventLabel: gaData.eventLabel
            });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gaId, orderId]);

    return (
        <CompoundSlider
            mode={mode}
            step={step}
            domain={domain}
            onUpdate={onUpdate}
            onSlideStart={onSlideStart}
            onSlideEnd={onSlideEnd}
            onChange={onChange}
            values={defaultValues.slice()}
            styleName={"styles.sliderWrapper"}
            className="hidden"
            disabled={disabled}
            rootStyle={sliderWrapperStyle}
        >
            <Rail>{({ getRailProps }) => <SliderRail railColor={railColor} getRailProps={getRailProps} trackSliderInnerStyle={trackSliderInnerStyle}/>}</Rail>
            <Handles>
                {({ handles, getHandleProps, activeHandleID }) => (
                    <div>
                        {handles.map((handle, index) => {
                            if (hideHandles.indexOf(index) !== -1) return null;
                            return (
                                <Handle
                                    key={handle.id}
                                    handle={handle}
                                    domain={domain}
                                    animatedHandle={animatedHandles.includes(index)}
                                    isActive={handle.id === activeHandleID}
                                    getHandleProps={getHandleProps}
                                    handleColor={handleColor}
                                    getHandleID={() => getHandleID(activeHandleID)}
                                    percentageHandler={percentageHandler}
                                    showPercentage={showPercentage}
                                    handleStyle={handleStyle}
                                />
                            );
                        })}
                    </div>
                )}
            </Handles>
            <Tracks {...trackProps}>
                {({ tracks, getTrackProps }) => (
                    <div>
                        {tracks.map(({ id, source, target }) => {
                            return (
                                <Track
                                    key={id}
                                    source={source}
                                    target={target}
                                    railColor={railColor}
                                    disabledTrackStyles={disabledTrackStyles}
                                    getTrackProps={getTrackProps}
                                    trackStyle={trackStyle}
                                />
                            );
                        })}
                    </div>
                )}
            </Tracks>
            <Ticks count={tickCount}>
                {({ ticks }) => (
                    <div style={ticksWrapperStyle}>
                        {ticks.map((tick, index) => {
                            return hideTicksOnEdges && (index === 0 || index === ticks.length - 1) ? null : (
                                <Tick key={tick.id} index={index} tick={tick} count={ticks.length} sliderTicksStyle={sliderTicksStyle} tickStyle={tickStyle}
                                    tickTextStyle={tickTextStyle} showTickText={showTickText} mainDivisorHeight={mainDivisorHeight}/>
                            );
                        })}
                    </div>
                )}
            </Ticks>
        </CompoundSlider>
    );
};

Slider.propTypes = {
    domain: PropTypes.array,
    defaultValues: PropTypes.array,
    step: PropTypes.number,
    mode: PropTypes.number,
    onChange: PropTypes.func,
    onUpdate: PropTypes.func,
    onSlideStart: PropTypes.func,
    onSlideEnd: PropTypes.func,
    tickCount: PropTypes.number,
    hideHandles: PropTypes.array,
    railColor: PropTypes.string,
    disabledTrackStyles: PropTypes.object,
    animatedHandles: PropTypes.array,
    handleColor: PropTypes.string,
    trackProps: PropTypes.object,
    hideTicksOnEdges: PropTypes.bool,
    disabled: PropTypes.bool,
    getHandleID: PropTypes.func,
    percentageHandler: PropTypes.func,
    showPercentage: PropTypes.bool,
    trackStyle: PropTypes.object,
    tickStyle: PropTypes.object,
    trackSliderInnerStyle: PropTypes.object,
    sliderTicksStyle: PropTypes.object,
    handleStyle: PropTypes.object,
    sliderWrapperStyle: PropTypes.object,
    showTickText: PropTypes.func,
    tickTextStyle: PropTypes.object,
    mainDivisorHeight: PropTypes.string,
    ticksWrapperStyle: PropTypes.object,
    orderId: PropTypes.string,
    gaId: PropTypes.string,
    localState: PropTypes.object,
    gaDataOnload: PropTypes.func
};

export default Slider;
